import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { Problem } from '../components/landing/Problem';
import { Solution } from '../components/landing/Solution';
import { CaseStudy } from '../components/landing/CaseStudy';
import { Features } from '../components/landing/Features';
import { ForResorts } from '../components/landing/ForResorts';
import { ForAgencies } from '../components/landing/ForAgencies';
import { AgencySignup } from '../components/landing/AgencySignup';
import { BusinessModel } from '../components/landing/BusinessModel';
import { AICapabilities } from '../components/landing/AICapabilities';
import { Roadmap } from '../components/landing/Roadmap';
import { CTASection } from '../components/landing/CTASection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-stone-50 font-sans text-stone-900" data-id="element-1278">
      <Navbar data-id="element-1279" />
      <main data-id="element-1280">
        <Hero data-id="element-1281" />
        <Problem data-id="element-1282" />
        <Solution data-id="element-1283" />
        <CaseStudy data-id="element-1284" />
        <Features data-id="element-1285" />
        <ForResorts data-id="element-1286" />
        <ForAgencies data-id="element-1287" />
        <AgencySignup data-id="element-1288" />
        <BusinessModel data-id="element-1289" />
        <AICapabilities data-id="element-1290" />
        <Roadmap data-id="element-1291" />
        <CTASection data-id="element-1292" />
      </main>
      <Footer data-id="element-1293" />
    </div>;
}